export const paddingInlineLarge = 20;

export const paddingInlineSmall = 12;
export const paddingInlineSmallBackground = 8;
